export function Logo({ variant = "color", className = "", height = "h-8" }) {
  const src = variant === "white" ? "/logo_white.png" : "/logo.png";
  return <img src={src} alt="Launch to Income" className={`${height} w-auto ${className}`} />;
}

export function FullPageLoader({ label = "Loading" }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[#FDFCFE]" data-testid="brand-loader">
      <div className="relative h-24 w-24">
        <svg viewBox="0 0 64 64" className="lti-rocket h-24 w-24" aria-hidden="true">
          {/* exhaust flame */}
          <path className="lti-flame" d="M32 44c-3.4 3-4.8 6.6-4.8 10.4C29 52.6 30.6 51 32 51s3 1.6 4.8 3.4C36.8 50.6 35.4 47 32 44z" fill="#3B82F6" />
          {/* body */}
          <path d="M32 6c6.6 5.2 10 12.6 10 21.4 0 4.6-1 8.8-2.8 12.4H24.8C23 36.2 22 32 22 27.4 22 18.6 25.4 11.2 32 6z" fill="#111444" />
          {/* nose accent */}
          <path d="M32 6c3.8 3 6.4 6.8 8 11.2H24c1.6-4.4 4.2-8.2 8-11.2z" fill="#1E2A78" />
          {/* window */}
          <circle cx="32" cy="24" r="5" fill="#EEF2FF" />
          <circle cx="32" cy="24" r="2.4" fill="#3B82F6" />
          {/* fins */}
          <path d="M24.8 40C21 41 18 43.6 16.4 47.4c3.4-.4 6-.2 8.4 1.2V40z" fill="#3B82F6" />
          <path d="M39.2 40c3.8 1 6.8 3.6 8.4 7.4-3.4-.4-6-.2-8.4 1.2V40z" fill="#3B82F6" />
        </svg>
        {/* launch trail */}
        <span className="lti-trail absolute left-1/2 top-[70%] h-2 w-2 -translate-x-1/2 rounded-full bg-brand/60" />
        <span className="lti-trail lti-trail-2 absolute left-[42%] top-[72%] h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-brand/40" />
        <span className="lti-trail lti-trail-3 absolute left-[58%] top-[72%] h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-brand/40" />
      </div>
      <img src="/logo.png" alt="Launch to Income" className="lti-word h-6 w-auto" />
      <div className="h-1 w-40 overflow-hidden rounded-full bg-brand-surface">
        <div className="lti-bar h-full w-1/3 rounded-full bg-brand" />
      </div>
      <p className="text-sm text-slate-500">{label}</p>
    </div>
  );
}

export function ReadinessBar({ label, value, sublabel }) {
  return (
    <div
      className="rounded-xl border border-brand-line bg-white p-4 shadow-soft"
      data-testid={`readiness-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <p className="text-sm text-slate-500">{label}</p>
      <p className="mt-0.5 font-heading text-2xl font-semibold">{value}%</p>
      <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-brand-surface">
        <div
          className="h-full rounded-full bg-brand transition-all duration-500"
          style={{ width: `${value}%` }}
        />
      </div>
      {sublabel && <p className="mt-2 text-xs text-slate-400">{sublabel}</p>}
    </div>
  );
}

export function ProvenanceBadge({ provenance }) {
  if (!provenance || provenance === "student_authored") return null;
  const label = provenance === "ai_assisted_edited" ? "AI assisted · edited" : "AI assisted";
  return (
    <span className="inline-flex items-center rounded-full bg-brand-surface px-2.5 py-0.5 text-xs font-medium text-brand-text">
      {label}
    </span>
  );
}
